

<template>
<div>
<vue-headful
	title="Altcoin to Fiat Currency Calculator - USD, Euro, GBP, Yen, Wan, AUD"
	description="Calculate how many altcoins you can buy using Bitcoin, Ethereum, or other primary coin for a given amount of fiat money USD, Euro, GBP, Yen, Wan, AUD, etc."
/>

<div id="breadcrumb" class="m-1">
<b-breadcrumb >
	<b-breadcrumb-item text="Home" href="#/"/>
	<b-breadcrumb-item text="Calculators" href="#/calculators/"/>
	<b-breadcrumb-item text="Fiat to Altcoin" active/>
</b-breadcrumb>
</div>
<select-settings />

<div id=tabs class="m-2">
<b-nav tabs>
  <b-nav-item :to="{name:'BitcoinCalc'}">Bitcoin</b-nav-item>
  <b-nav-item active>Altcoin</b-nav-item>
</b-nav>
</div>



<h1>Altcoin Purchase Calculator</h1>
<h3>Fiat <i class="fa fa-arrow-right" aria-hidden="true" title="to"></i> Bitcoin <i class="fa fa-arrow-right" aria-hidden="true" title="to"></i> Altcoin</h3>

<p class="lead">
Calculate how many altcoins you can buy for a given amount of money using an intermidate coin.
</p>


<b-col id=content sm=12 lg="8" offset-lg="2">
<b-form ref="form" :model="form" v-on:submit.prevent v-on:keyup.13="calculate">

<b-row align-v="start" class="wrap-container" align-h="center">

	<div class="responsive-column">
  		<b-popover target="bitcoinPrice" ref="popBitcoinPrice" placement="top" title="Bitcoin Price" triggers="focus" content="">
  			<p>Price of the base coin (BTC, ETH, etc) in your currency - dollars, euros, yen, etc</p>
  			<p>This is the intermediate coin used to purchase the altcoin.</p>
  			<p>How much of your currency does take to buy 1 base coin?</p>

  			<div class="container-fluid text-center">
  			<b-form-group label="Select Coin Price" label-for="basecoin-selection">
				<b-form-input id="basecoin-selection" size="sm" type="text" placeholder="Search coins" ref="basecoinSelection" v-model="selectedBasecoin"></b-form-input>
				<bitcoin-autocomplete v-bind:price-selected="selectBasecoinPrice" target="basecoinSelection"></bitcoin-autocomplete>
			</b-form-group>

			</div>
  		</b-popover>
		<b-form-group label="Bitcoin Price" >
    		<b-input-group class="">
			    <b-input-group-addon>
			     <i class="fa fa-usd" aria-hidden="true"></i>
			    </b-input-group-addon>
    			<b-form-input v-model="form.bitcoinPrice" id="bitcoinPrice" number @change="calculate('bitcoinPrice')" @focus.native="$event.target.select()" tabindex="1" class="" ></b-form-input>
    		</b-input-group>
  		</b-form-group>
  	</div >

	<div class="responsive-column">
		<b-popover target="altcoinPrice" ref="popAltcoinPrice" placement="top" title="Altcoin Price" triggers="focus" >
			<p>Price of the altcoin in terms of the base/intermediate coin - Bitcoin, Ethereum, etc</p>
			<p>How many base coins does it take to buy 1 altcoin?</p>

			<div class="container-fluid text-center">
			<b-form-group label="Select Coin Price" label-for="altcoin-selection">
				<b-form-input id="altcoin-selection" size="sm" type="text" placeholder="Search coins" ref="altcoinSelection" v-model="selectedAltcoin"></b-form-input>
				<bitcoin-autocomplete v-bind:currency-factory="getBasecoin" price-precision="8" v-bind:price-selected="selectAltcoinPrice" target="altcoinSelection"></bitcoin-autocomplete>
			</b-form-group>

		    </div>

		</b-popover>
  		<b-form-group label="Altcoin Price">
  			<b-input-group class="">
			    <b-input-group-addon>
			     <i class="fa fa-btc" aria-hidden="true"></i>
			    </b-input-group-addon>
    			<b-form-input v-model="form.altcoinPrice" id="altcoinPrice" number @change="calculate('altcoinPrice')" @focus.native="$event.target.select()" tabindex="2" class="" ></b-form-input>
    		</b-input-group>
  		</b-form-group>
  	</div >

  	<div class="responsive-column">
  		<b-popover target="total" ref="popTotal" placement="top" title="Total Amount" triggers="focus" content="Total amount to spend in your fiat currency - dollars, euros, yen, etc."></b-popover>
		<b-form-group label="Total Cost (fiat)" >
    		<b-input-group @focus="$event.target.select()" class="">
			    <b-input-group-addon>
			     <i class="fa fa-usd" aria-hidden="true"></i>
			    </b-input-group-addon>
    			<b-form-input v-model="form.total" id="total" number @change="calculate('total')" @focus.native="$event.target.select()" @keyup.native="fieldLocks['total']=true" tabindex="3" class="" ></b-form-input>
    			<b-input-group-addon >
			    	<i slot="suffix" v-bind:class="[fieldLocks.total ? 'fa-lock' : 'fa-unlock']" class="fa"  @click="toggleLock('total')"></i>
			    </b-input-group-addon>
    		</b-input-group>
  		</b-form-group>
  	</div >

 </b-row>

<b-row align-v="start" class="wrap-container" align-h="center" v-show="advancedMode">

	<b-col cols="0" md="3"></b-col>

	<b-col>
		<b-popover target="bitcoinAmount" ref="popBitcoinAmount" placement="top" title="Bitcoin Amount" triggers="focus" content="Number of primary coins to spend."></b-popover>
		<b-form-group label="Bitcoin Amount" >
    		<b-input-group @focus="$event.target.select()" class="">
			    <b-input-group-addon>
			    <i class="fa fa-btc" aria-hidden="true"></i>
			    </b-input-group-addon>
    			<b-form-input v-model="form.bitcoinAmount" id="bitcoinAmount" number @change="calculate('bitcoinAmount')" @focus.native="$event.target.select()" tabindex="6" class="" ></b-form-input>
	   		</b-input-group>
	  	</b-form-group>
	 </b-col>

	<b-col>
		<b-popover target="altcoinAmount" ref="popAltcoinAmount" placement="top" title="Altcoin Amount" triggers="focus" content="Number of altcoins that can be bought for the total spent."></b-popover>
		<b-form-group label="Altcoin Amount" >
    		<b-input-group @focus="$event.target.select()" class="">
			    <b-input-group-addon>
			     <i class="fa fa-btc" aria-hidden="true"></i>
			    </b-input-group-addon>
    			<b-form-input v-model="form.altcoinAmount" id="altcoinAmount" number @change="calculate('altcoinAmount')" @focus.native="$event.target.select()" tabindex="7" class="" ></b-form-input>
    		</b-input-group>
  		</b-form-group>
	</b-col>


	 <b-col  cols="0" md="3"></b-col>

</b-row>
<b-row align-v="start" class="wrap-container" align-h="center" >

	 <b-col cols="0" md="3"></b-col>
	 	<b-col align-self="center" class="no-label">
	  	<b-button-group>
			<b-button variant="success" @click="calculate" tabindex="4">Enter</b-button>
			<b-button variant="danger" @click="reset" tabindex="5">Reset</b-button>
			<b-button variant="secondary" @click="toggleAdvanced">
				<i class="fa fa-calculator" aria-hidden="true"></i>
			</b-button>
		</b-button-group>
	</b-col>
	<b-col  cols="0" md="3"></b-col>
</b-row>

<b-row align-v="start" class="wrap-container" align-h="center" v-show="this.tableData.length" >
	<b-card class="results" header="Results">
	<b-container fluid>
	<b-row>
	<b-col class="white-space-nowrap"><strong>Altcoin Price:</strong> <i class="fa fa-btc" aria-hidden="true"></i>{{ this.result.altcoinPrice }} (<i class="fa fa-usd" aria-hidden="true"></i>{{ Number(this.result.altcoinPrice / (1/this.result.bitcoinPrice)).toFixed(8) }}) </b-col>
	<b-col class="white-space-nowrap"><strong>Altcoin Amount:</strong> {{ this.result.altcoinAmount }}</b-col>
	<b-col class="white-space-nowrap"><strong>Bitcoin Price:</strong> <i class="fa fa-usd" aria-hidden="true"></i>{{ this.result.bitcoinPrice }}</b-col>
	<b-col class="white-space-nowrap"><strong>Bitcoin Amount:</strong> {{ this.result.bitcoinAmount }}</b-col>
	<b-col class="white-space-nowrap"><strong>Total Cost:</strong> <i class="fa fa-usd" aria-hidden="true"></i>{{ this.result.total }}</b-col>
	</b-row>


	<b-row class="mt-2" align-h="center">
		<b-col sm="*" class="m-1">
		<b-card title="Profit">
			<b-input-group @focus="$event.target.select()" class="" size="sm">
			    <b-input-group-addon>
			     <i :class="getProfitModeIcon()" aria-hidden="true" @click="toggleProfitMode"></i>
			    </b-input-group-addon>
    			<b-form-input v-model="profitLoss.profitAmount" id="profitAmount" number @change="calculateProfit('profitAmount')" @focus.native="$event.target.select()" tabindex="5" class="" ></b-form-input>
    			<b-input-group-button>
			      <b-btn variant="success" title="Calculate" @click="calculateProfit('profitAmount')"><i class="fa fa-calculator" aria-hidden="true"></i></b-btn>
			    </b-input-group-button>
    		</b-input-group>

    		<div class="mt-2">
				<div class="white-space-nowrap"><strong>Price:</strong> {{ this.profitLoss.profitPrice }}</div>
				<div class="white-space-nowrap"><strong>Profit %:</strong> {{ this.profitLoss.profitPercent }}</div>
				<div class="white-space-nowrap"><strong>Profit $:</strong> {{ this.profitLoss.profitTotal }}</div>

		  	</div>
  		</b-card>


	  	</b-col>

	  	<b-col sm="*" class="m-1">

	  	<b-card title="Loss">
			<b-input-group @focus="$event.target.select()" class="" size="sm">
			    <b-input-group-addon>
			     <i :class="getLossModeIcon()" aria-hidden="true" @click="toggleLossMode"></i>
			    </b-input-group-addon>
    			<b-form-input v-model="profitLoss.lossAmount" id="lossAmount" number @change="calculateProfit('lossAmount')" @focus.native="$event.target.select()" tabindex="5" class="" ></b-form-input>
    			<b-input-group-button>
			      <b-btn variant="success" title="Calculate" @click="calculateProfit('lossAmount')"><i class="fa fa-calculator" aria-hidden="true"></i></b-btn>
			    </b-input-group-button>
    		</b-input-group>

			<div class="mt-2">
	    		<div class="white-space-nowrap"><strong>Price:</strong> {{ this.profitLoss.lossPrice }}</div>
				<div class="white-space-nowrap"><strong>Loss %:</strong> {{ this.profitLoss.lossPercent }}</div>
				<div class="white-space-nowrap"><strong>Loss $:</strong> {{ this.profitLoss.lossTotal }}</div>
			</div>
  		</b-card>



	  	</b-col>

	</b-row>

	</b-container>
	</b-card>
</b-row>


</b-form>


<b-card class="mx-auto text-center" header="History" v-show="tableData.length > 0">
<b-row align-h="center" v-show="tableData.length > 0" id="historyTable">

		<b-table class=""  :items="tableData" :fields="tableFields" empty-text="..."  @row-clicked="rowClicked">
			<template slot="altcoinPrice" slot-scope="row" >
		      <i class="fa fa-btc" aria-hidden="true"></i>{{row.item.altcoinPrice}}
		    </template>
		    <template slot="altcoinAmount" slot-scope="row">
		      {{row.item.altcoinAmount}}
		    </template>
		    <template slot="bitcoinPrice" slot-scope="row">
		      <i class="fa fa-usd" aria-hidden="true"></i>{{row.item.bitcoinPrice}}
		    </template>
		    <template slot="bitcoinAmount" slot-scope="row" >
		      {{row.item.bitcoinAmount}}
		    </template>
		    <template slot="total" slot-scope="row">
		      <i class="fa fa-usd" aria-hidden="true"></i>{{row.item.total}}
		    </template>
		    <template slot="actions" slot-scope="row">
			  <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
			  <b-btn size="sm" @click.stop="rowDif(row.item,row.index,$event.target)"><i class="fa fa-search-minus" aria-hidden="true"></i></b-btn>
			</template>
		</b-table>


</b-row>
</b-card>

<b-modal ref="resultModal" id="modalInfo" @hide="resetModal" ok-only title="Results">

	<b-container fluid>
	<b-row>
	<b-col class="white-space-nowrap"><strong>Altcoin Price:</strong> <i class="fa fa-btc" aria-hidden="true"></i>{{ modalInfo.record.altcoinPrice }} (<i class="fa fa-usd" aria-hidden="true"></i>{{ Number(modalInfo.record.altcoinPrice / (1/modalInfo.record.bitcoinPrice)).toFixed(8) }}) </b-col>
	<b-col class="white-space-nowrap"><strong>Altcoin Amount:</strong> {{ modalInfo.record.altcoinAmount }}</b-col>
	<b-col class="white-space-nowrap"><strong>Bitcoin Price:</strong> <i class="fa fa-usd" aria-hidden="true"></i>{{ modalInfo.record.bitcoinPrice }}</b-col>
	<b-col class="white-space-nowrap"><strong>Bitcoin Amount:</strong> {{ modalInfo.record.bitcoinAmount }}</b-col>
	<b-col class="white-space-nowrap"><strong>Total Cost:</strong> <i class="fa fa-usd" aria-hidden="true"></i>{{ modalInfo.record.total }}</b-col>
	</b-row>
	</b-container>


	<div slot="modal-footer" class="w-200">

         <b-btn size="md" class="float-right m-1" variant="primary" @click="closeModal">
           Close
         </b-btn>

         <b-btn size="md" class="float-right m-1" variant="success" @click="restoreResult(modalInfo.record);">
           Restore
         </b-btn>
    </div>
</b-modal>

<b-modal ref="rowDifModal" id="rowDifModal" ok-only title="Difference">


	<b-container fluid>
	<b-row>
	<b-col class="white-space-nowrap"><strong>Total:</strong> <i class="fa fa-usd" aria-hidden="true"></i>{{ rowDifModalInfo.total }}</b-col>
	<b-col class="white-space-nowrap"><strong>Altcoin Price:</strong> <i class="fa fa-usd" aria-hidden="true"></i>{{ rowDifModalInfo.altcoinPrice }}</b-col>
	<b-col class="white-space-nowrap"><strong>Altcoin Amount:</strong> {{ rowDifModalInfo.altcoinAmount }}</b-col>
	<b-col class="white-space-nowrap"><strong>Bitcoin Price:</strong> <i class="fa fa-usd" aria-hidden="true"></i>{{ rowDifModalInfo.bitcoinPrice }}</b-col>
	<b-col class="white-space-nowrap"><strong>Bitcoin Amount:</strong> {{ rowDifModalInfo.bitcoinAmount }}</b-col>

	</b-row>

	</b-container>


	<div slot="modal-footer" class="w-200">

         <b-btn size="md" class="float-right m-1" variant="primary" @click="closeRowDifModal">
           Ok
         </b-btn>

    </div>
</b-modal>


</b-col> <!-- end content -->

</div>
</template>

<script>
//import lodash
var _ = require('lodash');

// import components
import BitcoinAutocomplete from '@/components/BitcoinAutocomplete';
import SelectSettings from '@/components/SelectSettings';

  export default {
    name: 'AltcoinCalc',
    components: {
    	'bitcoin-autocomplete': BitcoinAutocomplete,
    	'select-settings': SelectSettings
    },
    data() {
      return {
      	tabs: 'altcoin',
        form: {
          bitcoinPrice: 0,
          bitcoinAmount: 0,
          altcoinPrice: 0,
          altcoinAmount: 0,
          total: 0,
        },
        fieldLocks: {total:false},
        fieldClicks: {},
        tableData: [],
        tableFields: [
        	{key:"altcoinPrice", label:"Altcoin Price"},
        	{key:"altcoinAmount", label:"Altcoin Amount"},
        	{key:"bitcoinPrice", label:"Bitcoin Price", class:"d-none d-md-table-cell"},
        	{key:"bitcoinAmount", label:"Bitcoin Amount", class:"d-none d-sm-table-cell"},
        	{key:"total", label:"Total"},
        	{key:"actions", label:"Actions"}

        ],
        modalInfo: { record:{} },
        rowDifModalInfo: { total:0, amount:0, price:0 },
        difRow: null,
        advancedMode: false, // toggles full calculator,
        result: {},
        selectedBasecoin: null,
        selectedAltcoin: null,
        profitLoss: {
        	profitPrice: 0,
        	profitTotal: 0,
        	profitPercent: 0,
        	lossPrice: 0,
        	lossTotal: 0,
        	lossPercent: 0,
        	profitAmount: 0,
      	  	profitMode: 'percent',
      	 	lossAmount: 0,
      	 	lossMode: 'percent'
        }
      }
    },
    computed: {
    	// load getters from Vuex state
    	//...mapGetters(['coinPrice']),
		//bitcoinPrice: () => this.$root.$store.getters.coinPrice('BTC-USD'),
//		btcPrice: function() {
//			return  this.$root.$store.getters.coinPrice('BTC-USD')
//		},
//		ethPrice: function() {
//			return this.$root.$store.getters.coinPrice('ETH-USD')
//		}
    },
    mounted: function () {

		this.$nextTick(function () {
			// Code that will run only after the
			// entire view has been rendered

			// restore last profit/loss settings
			var profitAmount = this.rememberData('profitAmount') || 0;
			this.$set(this.profitLoss, 'profitAmount', profitAmount);

			var profitMode =  this.rememberData('profitMode') || 'percent';
			this.$set(this.profitLoss, 'profitMode', profitMode);

			var lossAmount =  this.rememberData('lossAmount') || 0;
			this.$set(this.profitLoss, 'lossAmount', lossAmount);

			var lossMode = this.rememberData('lossMode') || 'percent';
			this.$set(this.profitLoss, 'lossMode', lossMode);

		});
	},
    methods: {
      // load actions from Vuex state
      //...mapActions(['refreshCoinInfo']),
      onSubmit() {
        console.log('submit!');
      },
      getBasecoin() {
    	  if (this.selectedBasecoin) {
    		  return this.selectedBasecoin;
    	  }
    	  return null;
      },
      setBitcoinPrice(value) {
      	this.form.bitcoinPrice = value;
      	this.calculate('bitcoinPrice');
      },
      selectBasecoinPrice(value) {
      	// value is a CryptoCompare price object fired in popup coin selection
      	if ((value) && (value['PRICE'])) {
      		// clear out altcoin price info
      		this.form.altcoinPrice = 0;
      		this.selectedAltcoin = null; // clear selected altcoin name

      		// set basecoin price
      		this.setBitcoinPrice(value['PRICE']);
      		this.$root.$emit('bv::hide::popover', 'bitcoinPrice');
      	}
      },

      setAltcoinPrice(value) {
        	this.form.altcoinPrice = value;
        	this.calculate('altcoinPrice');
      },
      selectAltcoinPrice(value) {
      	// value is a CryptoCompare price object fired in popup coin selection
       	if ((value) && (value['PRICE'])) {
       		this.setAltcoinPrice(value['PRICE']);
       		this.$root.$emit('bv::hide::popover', 'altcoinPrice');
       	}
      },
      toggleAdvanced() {
      	if (!this.advancedMode) {
      		this.advancedMode = true;
      	} else {
      		this.advancedMode = false;
      	}
      },
      rowClicked(record, index) {
      	console.log(record, index);
      	this.modalInfo.record = record;
      	this.$root.$emit('bv::show::modal', 'modalInfo', '#historyTable');

      },
      restoreResult: function(record) {
      	// set form object to record
      	this.form = _.clone(record);
      	this.result = record;
      	this.$root.$emit('bv::hide::modal', 'modalInfo', '#total');
      },
	  tabClick(option) {
	    console.log(option);
	    if ((option) && (option.name) && (option.name === "bitcoin")) {
	    	this.$router.push({name:'BitcoinCalc'});
	    }
	  },
	  rowDif(record, index) {
      	console.log("rowDif", record, index);


      	/* It takes two rows to dif,
      	 * If this is the first row, just save it.
      	 * If it is the second, perform the dif and show results
      	 */
      	if (this.difRow === null) {
      		this.difRow = record;
      		this.$set(record, '_rowVariant', "info");
      		//record._rowVariant="info";
      	} else {
      		this.rowDifModalInfo.total = Number(this.difRow.total - record.total).toFixed(8);
      		this.rowDifModalInfo.bitcoinAmount = Number(this.difRow.bitcoinAmount - record.bitcoinAmount).toFixed(8);
      		this.rowDifModalInfo.bitcoinPrice = Number(this.difRow.bitcoinPrice - record.bitcoinPrice).toFixed(8);
      		this.rowDifModalInfo.altcoinAmount = Number(this.difRow.altcoinAmount - record.altcoinAmount).toFixed(8);
      		this.rowDifModalInfo.altcoinPrice = Number(this.difRow.altcoinPrice - record.altcoinPrice).toFixed(8);
      		this.$root.$emit('bv::show::modal', 'rowDifModal', '#historyTable');

      	}

      },
		clearRowDif() {
			this.difRow._rowVariant = null;
			this.difRow = null;

		},
		closeRowDifModal() {
			this.rowDifModalInfo.total = 0;
			this.rowDifModalInfo.amount = 0;
			this.rowDifModalInfo.price = 0;

			this.clearRowDif();
			this.$root.$emit('bv::hide::modal', 'rowDifModal', '#historyTable');
		},
//	recordInfo (record) {
//		this.modalInfo.title = `Row index: ${index}`
//		this.modalInfo.content = JSON.stringify(item, null, 2)
//		this.$root.$emit('bv::show::modal', 'modalInfo', button)
//	},
	closeModal() {
		this.$refs.resultModal.hide()
	},
	resetModal () {
		this.modalInfo.record = {};
	},

	toggleProfitMode() {
		this.profitLoss.profitMode = this.profitLoss.profitMode == "percent" ? "amount" : "percent";
		// recalculate profit
		this.calculateProfit('profitAmount');
	},
	getProfitModeIcon() {
		// return icon class
		if (this.profitLoss.profitMode == "percent") {
			return "fa fa-percent";
		} else {
			return "fa fa-usd";
		}
	},
	toggleLossMode() {
		this.profitLoss.lossMode = this.profitLoss.lossMode == "percent" ? "amount" : "percent";
		// recalculate loss
		this.calculateProfit('lossAmount');
	},
	getLossModeIcon() {
		// return icon class
		if (this.profitLoss.lossMode == "percent") {
			return "fa fa-percent";
		} else {
			return "fa fa-usd";
		}
	},

      toggleLock(field) {
        // toggle field locking on change
      	if (!this.fieldLocks[field]) {
      		this.fieldLocks[field] = true;
      	} else {
      		this.fieldLocks[field] = false;
      	}
      },

      calculate(field) {
		console.log(this);
		var value, mode;

		// lock fields as we go assuming the values entered manually are to be preserved
		if ((this.fieldLocks[field] !== undefined) && (this.fieldLocks[field] === false)) {
			// Only autolock on first click to the field
			if (this.fieldClicks[field] === undefined) {
				this.fieldClicks[field] = true;
				// Totals now lock when updated manually
//				this.fieldLocks.total = true;
			}

		}

		this.parseCalculatorFields(); // convert inputs to numbers


		var bitChanged = this.calculateBitcoin(field);
		var altChanged = this.calculateAltcoin(field);

		if ((bitChanged) || (altChanged) && (this.form.bitcoinAmount != 0) && (this.form.altcoinAmount != 0) && (this.form.total != 0)) {

			this.result = {'bitcoinPrice':this.form.bitcoinPrice, 'bitcoinAmount':this.form.bitcoinAmount, 'altcoinPrice':this.form.altcoinPrice, 'altcoinAmount':this.form.altcoinAmount, 'total':this.form.total};

			// save the result to the history table
			this.tableData.push(this.result);

			// recalculate profit/loss
      		this.calculateProfit('profitAmount');
      		this.calculateProfit('lossAmount');

		}

      },
      calculateBitcoin(field) {
		console.log(["calculateBitcoin", field]);
		var value, mode;

		if ((this.form.total == 0) || (this.form.bitcoinAmount == 0) || (this.form.bitcoinPrice == 0)) {


			// determine mode by which values are empty
			if ((this.form.total == 0) && (this.form.bitcoinAmount != 0) && (this.form.bitcoinPrice != 0)) {
				mode = "total";
			}
			else if ((this.form.bitcoinAmount == 0) && (this.form.bitcoinPrice != 0) && (this.form.total != 0)) {
				mode = "bitcoinAmount";
			}
			else if ((this.form.bitcoinPrice == 0) && (this.form.bitcoinAmount != 0)) {
				mode = "bitcoinPrice";
			} else if (this.form.bitcoinAmount == 0) {
				// this can happen if total and bitcoin amount is 0
				mode = "bitcoinAmount";
			}
		} else {
			// all of the fields have values, so recalculate based on what changed
			if (field === "bitcoinPrice") {

				mode = "bitcoinAmount";
				this.form.altcoinAmount = 0; // recalculate altcoin totals


			} else if (field === "bitcoinAmount") {

				mode = "bitcoinPrice";
				this.form.altcoinAmount = 0; // recalculate altcoin totals

			}
			// ignore changes  to total field here because we dont know whether to calculate new bitcoin or altcoin when total changes
			else if (field === "total") {
				mode = "bitcoinAmount";
				// wipe out altcoinAmount so it will be recalculated
				this.form.altcoinAmount = 0;
			}
		}

		// calculate total cost
		// We should only calculate total field after altcoin calculation, not here
		if (mode === "total")  {
      		value = Number(this.form.bitcoinPrice) * Number(this.form.bitcoinAmount);
			this.form.total = value.toFixed(8); // fiat price has 2 decimals

      		return true;
      	}
      	// calculate coin amount
		if (mode === "bitcoinAmount") {
      		value = Number(this.form.total) / Number(this.form.bitcoinPrice);
      		this.form.bitcoinAmount = value.toFixed(8); // bitcoin can have 8 decimals

      		return true;
      	}
      	else if (mode === "bitcoinPrice") {
      		value = Number(this.form.total) / Number(this.form.bitcoinPrice);
      		this.form.bitcoinAmount = value.toFixed(8); // bitcoin can have 8 decimals

      		return true;
      	}

      	return false;

      },

      calculateAltcoin(field) {
		console.log(["calculateAltcoin",field]);
		var value, mode;

		// First calculate bicoin info
		if (this.form.bitcoinPrice == 0) {
			this.calculateBitcoin(field);
		}
		if (this.form.bitcoinAmount == 0) {
			//console.log("Error: Bitcoin amount is required to calculate altcoin");
			return false;
		}
		if ((this.form.altcoinAmount == 0) || (this.form.altcoinPrice == 0)) {


			// determine mode by which values are empty
			if ((this.form.altcoinAmount == 0) && (this.form.altcoinPrice != 0)) {
				mode = "altcoinAmount"
			}
			else if ((this.form.altcoinAmount != 0) && (this.form.altcoinPrice == 0)) {
				mode = "altcoinPrice"
			}

		} else {
			// all of the fields have values, so recalculate based on what changed
			if (field === "altcoinPrice") {
				if (this.fieldLocks.total === true) {
					// Total is locked, so calculate amount of altcoins
					mode = "altcoinAmount";
				} else {
					// Recaculate total cost after value of altcoin changed
					mode = "total";
				}
			} else if (field === "altcoinAmount") {
				if (this.fieldLocks.total === true) {
					mode = "altcoinPrice";
				} else {
					mode = "total";
				}
			} else if ((field === "bitcoinAmount") || (field === "bitcoinPrice")) {
				if (this.fieldLocks.total === true) {
					mode = "altcoinAmount";
				} else {
					mode = "total";
				}
			} else if (field === "total") {
				if (this.form.total == 0) {
					mode = "total";
				} else {
					mode = "altcoinAmount";
				}
			}
		}

      	// calculate coin amount
		if (mode === "altcoinAmount") {
      		value = (Number(this.form.bitcoinAmount) / Number(this.form.altcoinPrice));
      		this.form.altcoinAmount = value.toFixed(8); // altcoin can have 8 decimals

      		return true;
      	}
      	else if (mode === "altcoinPrice") {

      		// price is bitcoin amount / altcoin amoun
      		value = Number(this.form.bitcoinAmount) / Number(this.form.altcoinAmount);
      		this.form.altcoinPrice = value.toFixed(8); // bitcoin can have 8 decimals

      		return true;
      	}
		if (mode === "total") {
			// TotalDollars = AltcoinAmount * AltcoinPrice * BitcoinPrice
			value = this.form.altcoinAmount * this.form.altcoinPrice * this.form.bitcoinPrice;

      		this.form.total = value.toFixed(8); // fiat to 2 decimals

      		return true;
      	}

      	return false;

      },

      calculateProfit(field) {
      	var value, mode, type, amount, price, total, percent;

		if (field === "profitAmount") {

			mode = this.profitLoss.profitMode;
			amount = Number(this.profitLoss.profitAmount);
			type = "profit";

		} else if (field === "lossAmount") {
			mode = this.profitLoss.lossMode;
			amount = Number(this.profitLoss.lossAmount * -1);
			type = "loss";
		}

		// do not proceed if amount is empty.
		if ((amount === undefined) || (amount === null) || (amount == 0) || (amount === "")) {
			return null;
		}

		if (mode === "percent") {


			price = Number(Number(this.form.altcoinPrice) + (Number(this.form.altcoinPrice) * (Number(amount)/100))).toFixed(8);
			total = Number( (Number(this.form.total) * (Number(amount)/100))).toFixed(8);
			percent = amount;

		}
		else if (mode === "amount") {
			// Used this.$set to force values to change in view, otherwise some values were not updating.
			var valueDiff = (Number(amount) / Number(this.form.total));
			price = Number((Number(this.form.altcoinPrice) * valueDiff) + Number(this.form.altcoinPrice)).toFixed(8);
			total = Number(Number(this.form.total) * valueDiff).toFixed(8);
			percent = Number(Number(this.profitLoss.profitTotal) / (Number(this.form.total)) * 100).toFixed(8);
			this.$set(this.profitLoss, 'profitPrice', (Number((Number(this.form.altcoinPrice) * valueDiff) + Number(this.form.altcoinPrice)).toFixed(8)));
			//this.profitLoss.profitTotal = Number(Number(this.form.total) * valueDiff).toFixed(8);
			this.$set(this.profitLoss, 'profitTotal', Number(Number(this.form.total) * valueDiff).toFixed(8));
			//this.profitLoss.profitPercent = Number(Number(this.profitLoss.profitTotal) / (Number(this.form.total)) * 100).toFixed(8);
			this.$set(this.profitLoss, 'profitPercent', Number(Number(this.profitLoss.profitTotal) / (Number(this.form.total)) * 100).toFixed(8));

		}

		// Update the values on the page
		this.$set(this.profitLoss, type+'Price', price);
		this.$set(this.profitLoss, type+'Total', total);
		this.$set(this.profitLoss, type+'Percent', percent);

		// Save current profit/loss preferences
		this.rememberData('profitAmount', this.profitLoss.profitAmount);
		this.rememberData('profitMode', this.profitLoss.profitMode);
		this.rememberData('lossAmount', this.profitLoss.lossAmount);
		this.rememberData('lossMode', this.profitLoss.lossMode);

      },
      resetProfitLoss() {
      	this.profitLoss.profitPrice = 0;
      	this.profitLoss.profitPercent = 0;
      	this.profitLoss.profitTotal = 0;
      	this.profitLoss.lossPrice = 0;
      	this.profitLoss.lossPercent = 0;
      	this.profitLoss.lossTotal = 0;
      },

      parseCalculatorFields() {

    	this.form.bitcoinPrice = Number(this.form.bitcoinPrice);
        this.form.bitcoinAmount = Number(this.form.bitcoinAmount);
        this.form.altcoinPrice = Number(this.form.altcoinPrice);
        this.form.altcoinAmount = Number(this.form.altcoinAmount);
        this.form.total = Number(this.form.total);
      },

      reset() {
      	this.form.bitcoinPrice = 0;
      	this.form.bitcoinAmount = 0;
      	this.form.altcoinPrice = 0;
      	this.form.altcoinAmount = 0;
      	this.form.total = 0;
      	this.resetProfitLoss();
      },
      rememberData(key, value) {
			// loads values from Cookies

			if (value !== undefined) {
				// set a cookie
				this.$cookies.set(key, value);
			}
			else if (key !== undefined) {
				// get a cookie
				return this.$cookies.get(key)
			}
		}

    }
  }
</script>

<style >
.primary-field {
	border: 1px solid #E6A23C;
}
.wrap-container {
	flex-wrap: wrap;
}
.responsive-column {
	margin: 4px;
}
.box-card {
	width: 200px;
	margin: 5px;
}

.no-label {

	padding-top:14px
}
</style>


// WEBPACK FOOTER //
// src/components/AltcoinCalc.vue